const arrayKeys = [
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "AA",
  "AB",
  "AC",
  "AD",
  "AE",
  "AF",
  "AG",
  "AH",
  "AI",
  "AJ",
  "AK",
  "AL",
  "AM",
  "AN",
  "AO",
  "AP",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
]

export const compileKeysObject = (array) => {
  const newArray = []
  const finalArray = []
  for (let i = 0; i < array.length; i++) {
    for (let j = 0; j < array[i].list.length; j++) {
      if (array[i].type == 'questionsOnScale' && array[i].list[j]?.range) newArray.push(array[i].list[j]?.range)
      if (array[i].list[j]?.answer) newArray.push(array[i].list[j]?.answer)
      if (!array[i].list[j]?.answer && array[i].list[j]?.isChecked) newArray.push(array[i].list[j].name)
    }
  }
  for (let i = 0; i < newArray.length; i++) {
    finalArray.push({ key: arrayKeys[i], value: newArray[i] }) // собираем проверочный массив с ключами
  }
  return finalArray
}

const baseUrl =
  "https://script.google.com/macros/s/AKfycbwmdAoxAp27d56FCHTX0CfP-hFVGejXiKaidSN-1hb57i5MLZ9hGwu2keapOXzxrt5o/exec";
export const senderRow = (data, arrayForSend) =>
  `${baseUrl}?action=addTask&rowIndex=1&data=${data}&${arrayForSend.map(el => `${el.key}=${el.value}&`)}`
    .toString()
    .replace(/,/g, "")
    .replace(/%/g, "")
    .replace(/true/g, "да")
    .replace(/undefined/g, "").slice(0, -1)



